import { create } from "zustand";
import { axiosHelper, tokenHelper } from "../helpers";
import { filterNonFalseValues } from "../helpers/Utlis";

export const useDeviceStore = create((set, get) => ({
  devices: [],
  isLoading: false,
  isError: false,
  error: undefined,
  pagination: null,
  filters: {
    code: "",
    DestProv: "",
    dateFrom: "",
    dateTo: "",
    access: "",
    driverId: "",
    charger: false,
  },
  // Methods
  createDevice: async (body) => {
    set({ isLoading: true });

    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();

      // Post the device creation request
      const response = await axiosHelper.post("/devices", body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      // Refresh the list of devices
      await get().getDevices();
      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  getDevices: async (spaceId, page = 1, perPage = 50) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });

      let url = `/devices?page=${page}&perPage=${perPage}`;
      if (spaceId) {
        url = `/devices/space/${spaceId}?page=${page}&perPage=${perPage}`;
      }

      let response = await axiosHelper.get(url, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      set({
        devices: response.devices || response,
        pagination: response.pagination,
        isLoading: false,
      });
      return response;
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  updateDevice: async (deviceId, info) => {
    try {
      const accessToken = await tokenHelper.getToken();

      set({ isLoading: true });
      let response = await axiosHelper.patch(`/devices/${deviceId}`, info, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      get().getDevices();
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  deleteDevice: async (deviceId) => {
    try {
      set({ isLoading: true });
      const accessToken = await tokenHelper.getToken();

      let response = await axiosHelper.delete(`/devices/${deviceId}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      get().getDevices();
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  configureButton: async (deviceId, buttonNumber, orderConfig) => {
    try {
      const accessToken = await tokenHelper.getToken();

      set({ isLoading: true });
      let response = await axiosHelper.post(
        `/devices/configure-button`,
        {
          device_id: deviceId,
          button_number: buttonNumber,
          order_config: orderConfig,
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      get().getDevices();
      return response;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  setFilters: (filters) => {
    set({ filters: filterNonFalseValues(filters) });
  },
}));

